export const lerpNum = (a: number, b: number, perc: number): number => a + (b - a) * perc;

const clampInt = (value: number, min: number, max: number): number => {
    if (value < min) return min;
    if (value > max) return max;
    return value;
};

export const lerpColors = (a: number[], b: number[], perc: number): number[] => [
    clampInt(lerpNum(a[0], b[0], perc), 0, 255),
    clampInt(lerpNum(a[1], b[1], perc), 0, 255),
    clampInt(lerpNum(a[2], b[2], perc), 0, 255),
    clampInt(lerpNum(a[3], b[3], perc), 0, 255),
];

export const colorsToCSS = (color: number[]): string => `rgb(${color[0]}, ${color[1]}, ${color[2]})`;
